import React, { createContext, PropsWithChildren } from 'react'

type CSSVar = `--${string}`

export const APP_HEADER_RELATIVE_OFFSET_CSS_VAR: CSSVar = '--app-header-relative-offset'
export const APP_HEADER_FLOATING_OFFSET_CSS_VAR: CSSVar = '--app-header-floating-offset'

export type AppHeaderSection =
  | 'primary-header'
  | 'tertiary-header'
  | 'contact-options-banner'
  | 'notification-banner'
  | 'banners-stack'

export type AppHeaderSectionPosition = 'static' | 'sticky' | 'fixed' | 'hidden'

interface ObservedHeight {
  relative: number
  floating: number
}

const observedHeights: Record<AppHeaderSection, ObservedHeight> = {
  'primary-header': { relative: 0, floating: 0 },
  'tertiary-header': { relative: 0, floating: 0 },
  'contact-options-banner': { relative: 0, floating: 0 },
  'notification-banner': { relative: 0, floating: 0 },
  'banners-stack': { relative: 0, floating: 0 },
}

const appHeaderHandler = (
  section: AppHeaderSection,
  rect: DOMRect | undefined,
  /** @default static */
  position: AppHeaderSectionPosition = 'static',
) => {
  if (position === 'hidden' || !rect) {
    observedHeights[section].relative = 0
    observedHeights[section].floating = 0
  } else {
    switch (position) {
      case 'static':
        observedHeights[section].relative = rect.height
        observedHeights[section].floating = 0
        break
      case 'sticky':
        observedHeights[section].relative = rect.height
        observedHeights[section].floating = rect.height
        break
      case 'fixed':
        observedHeights[section].relative = 0
        observedHeights[section].floating = rect.height
    }
  }
  const [relativeOffset, floatingOffset] = Object.values(observedHeights).reduce(([currRelative, currFloating], height) => {
    return [currRelative + height.relative, currFloating + height.floating]
  }, [0, 0])
  document.documentElement.style.setProperty(APP_HEADER_RELATIVE_OFFSET_CSS_VAR, `${relativeOffset}px`)
  document.documentElement.style.setProperty(APP_HEADER_FLOATING_OFFSET_CSS_VAR, `${floatingOffset}px`)
}

const AppHeaderContext = createContext<typeof appHeaderHandler>(appHeaderHandler)

export function AppHeaderContextProvider(props: PropsWithChildren) {
  return <AppHeaderContext.Provider {...props} value={appHeaderHandler} />
}

export default AppHeaderContext
